import React, { Component } from "react";
import CourseTable from "./RoutineTable";
import CourseAdd from "./RoutineAdd";
import { LinearProgress } from "@material-ui/core";
import Snack from "../../Snackbar/Snack";
import { PostData, GetData, PutData, DeleteData } from "../../../api/service";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import RequestTable from "./RequestTable";
import PageHeading from "../PageHeading";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

class CertificateView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      isLoading: true,
      status: false,
      message: "",
      table_data: [],
      edit: false,
      edit_data: [],
      is_all_loaded: false,
      requests: [],
      isRequestLoaded: false,
    };
  }

  __getRequests() {
    GetData(`/getcertificaterequests`).then((resp) => {
      //console.log(resp)
      this.setState({
        requests: resp.filter(el => el.status != 1),
        isRequestLoaded: true,
        table_data: resp.filter(el => el.status == 1),
        isLoading: false,
      });
    });
  }

  __getData() {
    // GetData(`/getcertificate`).then((resp) => {
    //   //console.log(resp)
    //   this.setState({
    //     table_data: resp,
    //     isLoading: false,
    //   });
    // });
  }

  componentDidMount() {
    this.__getRequests();
    this.__getData();
  }

  onAddClick() {
    this.setState({
      show: !this.state.show,
      edit: false,
    });
  }

  setData(data) {
    //send the data to the server

    PostData(
      `/${this.props.apikey}/${this.props.username}/addcertificate`,
      data
    ).then((resp) => {
      //console.log(resp);
      this.setState({
        show: false,
        status: true,
        message: resp,
        edit: false,
      });
      this.__getData();
    });
  }

  actionClick(el) {
    this.setState({
      edit: true,
      edit_data: el,
      show: true,
    });
  }

  printClick(id) {
    this.props.history.push("/certificate/print", id);
  }

  esetData(data) {
    //send the data to the server

    PutData(
      `/${this.props.apikey}/${this.props.username}/${data.id}/updatecertificate`,
      data
    ).then((resp) => {
      //console.log(resp);
      this.setState({
        show: false,
        status: true,
        message: resp,
      });
      this.__getData();
    });
  }

  onDeleteClick(id) {
    this.setState({
      show: false,
    });
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: this.onDeleteConfirm.bind(this, id),
        },
        {
          label: "No",
        },
      ],
    });
  }

  onDeleteConfirm(id) {
    DeleteData(
      `/${this.props.apikey}/${this.props.username}/${id}/deletecertificate`
    ).then((resp) => {
      this.setState({
        show: false,
        status: true,
        message: resp,
      });
      this.__getData();
    });
  }

  render() {
    return (
      <div style={{ padding: "14px 8px 24px" }}>
        <PageHeading
          icon={<AssignmentTurnedInIcon style={{ fontSize: 26 }} />}
          title="Certificate Requests & Issued Certificates"
          subtitle="Process incoming requests, then review every certificate already generated."
        />
        {this.state.status ? (
          <Snack
            open={this.state.status}
            message={this.state.message}
            handleClose={() =>
              this.setState({
                status: false,
                message: "",
              })
            }
          />
        ) : null}
        {this.state.isLoading ? <LinearProgress color="secondary" /> : null}

        <CourseAdd
          show={this.state.show}
          handleClose={this.onAddClick.bind(this)}
          setData={this.setData.bind(this)}
          edit={this.state.edit}
          edit_data={this.state.edit_data}
          esetData={this.esetData.bind(this)}
          onDeleteClick={this.onDeleteClick.bind(this)}
          is_all_loaded={this.state.is_all_loaded}
        />

        {this.state.isRequestLoaded ? (
          <RequestTable
            table_data={this.state.requests}
            isRequestLoaded={this.state.isRequestLoaded}
            username={this.props.username}
            apikey={this.props.apikey}
            // onAddClick={this.onAddClick.bind(this)}
            // printClick={this.printClick.bind(this)}
            __getRequests={this.__getRequests.bind(this)}
            actionClick={this.actionClick.bind(this)}
            reloadAllData={() => {
              this.__getRequests()
              this.__getData()
            }}
          />
        ) : null}
        <br />
        {!this.state.isLoading ? (
          <CourseTable
            table_data={this.state.table_data}
            isLoading={this.state.isLoading}
            onAddClick={this.onAddClick.bind(this)}
            printClick={this.printClick.bind(this)}
            actionClick={this.actionClick.bind(this)}
          />
        ) : null}
      </div>
    );
  }
}

export default CertificateView;
